import React from "react"
import "./Modal.css"
import ModalButtons from "./ModalButton.module.css"

const Modal = (props) => {
  return (
    <div className="modalWrapper">
      <div
        className="mainModal"
        // style={{ backgroundImage: `url(${props.image})` }}
      >
        <img src={props.image} alt="YO err" className="image" />

        {/* Button  */}
        <div
          className={ModalButtons.closeContainer}
          onClick={props.closeModalHandler}
        >
          <div className={ModalButtons.leftright} />
          <div className={ModalButtons.rightleft} />
          <div className={ModalButtons.close}>close</div>
        </div>
      </div>
    </div>
  )
}
export default Modal
